<template>
    <div v-show="visible === true"
        ref="element"
        class="context-menu"
        :style="'top: ' + position.top + 'px; left:' + position.left + 'px;'"
    >
        <slot name="menu_items" v-if="visible === true">

        </slot>
    </div>
</template>

<script setup>
  import {defineExpose, ref, nextTick} from 'vue';
  import {onMounted}               from 'vue';
  import ContextMenuController         from '@/js/Webmail/ContextMenuController';

  const context_menu_controller = ContextMenuController;
  const global_listeners        = ref(false);
  const iframe_elements         = [];
  const hide_disabled           = ref(false);
  const visible                 = ref(false);
  const element                 = ref();
  const position                = ref({
    top     : 0,
    left    : 0
  });

  onMounted(() => {
    setIframeElements();
  });


  const contextMenuShow = async () => {
    unsetLastTargetClass();
    setTargetClass();
    setPositionTop(context_menu_controller.event.pageY);
    setPositionLeft(context_menu_controller.event.pageX);
    setVisible(true);
    disableHide();
    setGlobalListeners();
    setIframeListeners();
    await nextTick();
    adjustMargins();
  }

  const contextMenuHide = () => {
    if (hide_disabled.value === true) {
      enableHide();
      return;
    }

    if (global_listeners.value === true) {
      unsetGlobalListeners();
      unsetIframeListeners();
    }

    unsetTargetClass();
    setPositionTop(0);
    setPositionLeft(0);
    setVisible(false);
  }

  const adjustMargins = () => {
    let rect = element.value.getBoundingClientRect();

    if (rect.bottom > document.body.clientHeight) {
      setPositionTop(position.value.top - (rect.bottom - rect.top));
    }

    if (rect.right > document.body.clientWidth) {
      setPositionLeft(position.value.left - (rect.right - rect.left));
    }
  }

  const setGlobalListeners = () => {
    window.addEventListener('contextmenu', contextMenuHide);
    window.addEventListener('click'      , contextMenuHide);
    window.addEventListener('keydown'    , contextMenuHide);
  }

  const unsetGlobalListeners = () => {
    window.removeEventListener('contextmenu', contextMenuHide);
    window.removeEventListener('click'      , contextMenuHide);
    window.removeEventListener('keydown'    , contextMenuHide);
  }

  const setIframeElements = () => {
    let iframes = document.querySelectorAll('iframe');

    iframes.forEach(iframe => {
      try {
        let doc = iframe.contentDocument || iframe.contentWindow.document;
        iframe_elements.push(doc);
      } catch (e) {
        // If we cannot access the iframe's document, it might be cross-origin.
        return;
      }
    });
  }

  const setIframeListeners = () => {
    iframe_elements.forEach(iframe => {
      iframe.addEventListener('click', contextMenuHide);
    });
  }

  const unsetIframeListeners = () => {
    iframe_elements.forEach((iframe) => {
      iframe.removeEventListener('click', contextMenuHide);
    });
  }

  const setTargetClass = () => {
    context_menu_controller.target.classList.add('context-menu-active');
  }

  const unsetTargetClass = () => {
    if (!context_menu_controller.target) {
      return;
    }

    context_menu_controller.target.classList.remove('context-menu-active');
  }

  const unsetLastTargetClass = () => {
    if (!context_menu_controller.last_target) {
      return;
    }

    context_menu_controller.last_target.classList.remove('context-menu-active');
  }

  const setVisible = (display) => {
    visible.value        = display;
  }

  const disableHide = () => {
    hide_disabled.value = true;
  }

  const enableHide = () => {
    hide_disabled.value = false;
  }

  const setPositionTop = (top) => {
    position.value.top = top;
  }

  const setPositionLeft = (left) => {
    position.value.left = left;
  }

  defineExpose({
    show : contextMenuShow,
    hide : contextMenuHide
  })
</script>